import type { ComponentProps } from 'react';

import { Brand, Button } from '@sso/shared/core';

function MicrosoftButton(props: ComponentProps<typeof Button>) {
    return (
        <Button
            iconLeft={<Brand name="microsoft" size="lg" />}
            data-testid="microsoft-signin-button"
            appearance="ghostBlue"
            {...props}
        />
    );
}

export default MicrosoftButton;
